module.exports = __webpack_public_path__ + "static/media/iconLevel9.318998bc.png";